export const CONSENT_CHANGED_BROADCAST_EVENT = 'consentChanged'
